import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router/immutable';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunkMiddleware from 'redux-thunk';
import { fromJS } from 'immutable';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

export default (initialState = fromJS({})) => {
  const history = createBrowserHistory();
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [
    thunkMiddleware,
    routerMiddleware(history),
    sagaMiddleware,
  ];

  const newCreateStore = Reflect.apply(
    applyMiddleware,
    null,
    middleware,
  )(createStore);

  const reducer = rootReducer(history);

  const store =
    typeof __DEVELOPMENT__ !== 'undefined' && __DEVELOPMENT__
      ? newCreateStore(
          reducer,
          initialState,
          window?.__REDUX_DEVTOOLS_EXTENSION__?.(),
        )
      : newCreateStore(reducer, initialState || new Map());

  sagaMiddleware.run(rootSaga);

  return {
    history,
    store,
  };
};
